class SimpleSlider {
    constructor(sliderElement, options = {}) {
        this.slider = sliderElement;
        this.slidesContainer = this.slider.querySelector('.slides');
        this.slides = this.slider.querySelectorAll('.slide');
        this.currentIndex = 0;
        this.intervalTime = options.intervalTime || 3000;
        this.autoPlay = options.autoPlay !== false;
        this.showArrows = options.showArrows !== false;
        this.interval = null;
        
        this.init();
    }
    
    init() {
        if (this.slides.length === 0) return;
        
        this.updateSliderPosition();
        
        if (this.showArrows) {
            this.createArrows();
        }
        
        if (this.autoPlay) {
            this.startAutoPlay();
        }
        
        this.slider.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.slider.addEventListener('mouseleave', () => this.startAutoPlay());
        
        this.addTouchSupport();
    }
    
    updateSliderPosition() {
        const offset = -this.currentIndex * 100;
        this.slidesContainer.style.transform = `translateX(${offset}%)`;
    }
    
    createArrows() {
        // FIX: arrows now have SVG icons (were empty strings before)
        const leftArrow = document.createElement('button');
        leftArrow.className = 'slider-arrow slider-arrow-left';
        leftArrow.setAttribute('aria-label', 'Previous slide');
        leftArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
        leftArrow.addEventListener('click', (e) => {
            e.stopPropagation();
            this.prevSlide();
            this.resetAutoPlay();
        });
        
        const rightArrow = document.createElement('button');
        rightArrow.className = 'slider-arrow slider-arrow-right';
        rightArrow.setAttribute('aria-label', 'Next slide');
        rightArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        rightArrow.addEventListener('click', (e) => {
            e.stopPropagation();
            this.nextSlide();
            this.resetAutoPlay();
        });
        
        this.slider.appendChild(leftArrow);
        this.slider.appendChild(rightArrow);
    }
    
    nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.updateSliderPosition();
    }
    
    prevSlide() {
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.updateSliderPosition();
    }
    
    resetAutoPlay() {
        if (this.autoPlay) {
            this.stopAutoPlay();
            this.startAutoPlay();
        }
    }
    
    startAutoPlay() {
        if (!this.autoPlay) return;
        this.stopAutoPlay();
        this.interval = setInterval(() => this.nextSlide(), this.intervalTime);
    }
    
    stopAutoPlay() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    
    addTouchSupport() {
        let touchStartX = 0;
        let touchEndX = 0;
        
        this.slider.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        });
        
        this.slider.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        });
        
        this.handleSwipe = () => {
            const swipeThreshold = 50;
            const diff = touchEndX - touchStartX;
            
            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    this.prevSlide();
                } else {
                    this.nextSlide();
                }
                this.resetAutoPlay();
            }
        };
    }
}

document.addEventListener('DOMContentLoaded', function() {

    // --- Top Slider ---
    const sliderElement = document.querySelector('.top-slider');
    if (sliderElement) {
        new SimpleSlider(sliderElement, {
            intervalTime: 3000,
            autoPlay: true,
            showArrows: true
        });
    }

    // --- Subcategory Toggle ---
    const toggleButtons = document.querySelectorAll('.subcategory-toggle');
    toggleButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            this.classList.toggle('open');
            
            const parentItem = this.closest('.left-subcategory-item');
            const childList = parentItem.querySelector('.left-subcategory-child-list');
            
            if (childList) {
                if (childList.classList.contains('visible')) {
                    childList.classList.remove('visible');
                    childList.classList.add('hidden');
                    this.setAttribute('aria-expanded', 'false');
                } else {
                    childList.classList.remove('hidden');
                    childList.classList.add('visible');
                    this.setAttribute('aria-expanded', 'true');
                }
            }
        });
    });

    // Auto-open active parent on page load
    const activeParents = document.querySelectorAll('.left-subcategory-item.active-parent');
    activeParents.forEach(parent => {
        const toggle = parent.querySelector('.subcategory-toggle');
        const childList = parent.querySelector('.left-subcategory-child-list');
        if (toggle && childList) {
            toggle.classList.add('open');
            childList.classList.remove('hidden');
            childList.classList.add('visible');
            toggle.setAttribute('aria-expanded', 'true');
        }
    });

    // --- Collection Description Read More ---
    // FIX: use scoped references inside the container instead of global querySelector
    const desc = document.querySelector('.collection-hero__description');
    if (desc && desc.scrollHeight > 170) {
        const html = desc.innerHTML;
        const short = document.createElement('div');
        short.className = 'desc-short';
        short.style.cssText = 'max-height:170px; overflow:hidden';
        short.innerHTML = html;

        const full = document.createElement('div');
        full.className = 'desc-full';
        full.style.display = 'none';
        full.innerHTML = html;

        const btnMore = document.createElement('button');
        btnMore.className = 'btn-more';
        btnMore.textContent = 'Read more →';

        const btnLess = document.createElement('button');
        btnLess.className = 'btn-less';
        btnLess.style.display = 'none';
        btnLess.textContent = 'Read less ↑';

        btnMore.addEventListener('click', function() {
            short.style.display = 'none';
            full.style.display = 'block';
            btnMore.style.display = 'none';
            btnLess.style.display = 'inline-flex';
        });

        btnLess.addEventListener('click', function() {
            full.style.display = 'none';
            short.style.display = 'block';
            btnLess.style.display = 'none';
            btnMore.style.display = 'inline-flex';
            desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        desc.innerHTML = '';
        desc.appendChild(short);
        desc.appendChild(full);
        desc.appendChild(btnMore);
        desc.appendChild(btnLess);
    }

    // --- Subcategory Swiper ---
    const swiperContainer = document.querySelector('.subcategory-list-grid');
    if (swiperContainer && typeof Swiper !== 'undefined') {
        new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 15,
            freeMode: true,
            grabCursor: true,
            loop: false,
            speed: 400,
        });
    }

    // --- Delivery Time ---
    // FIX: locale is now read from a data attribute set by delivery-init.liquid
    // instead of using a Liquid tag inside this static JS file
    const cacheKey = 'delivery_calculation_' + new Date().toDateString();
    const cachedResult = localStorage.getItem(cacheKey);

    if (cachedResult) {
        updateDeliveryElements(JSON.parse(cachedResult));
    } else {
        const localeEl = document.getElementById('poco-locale-data');
        const locale = localeEl ? localeEl.dataset.locale : 'en';
        const result = calculateDeliveryTime(locale);
        localStorage.setItem(cacheKey, JSON.stringify(result));
        updateDeliveryElements(result);
    }

});

function calculateDeliveryTime(locale) {
    const nyTimeStr = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
    const nyTime = new Date(nyTimeStr);

    const currentDay = nyTime.getDay();
    const currentHour = nyTime.getHours();
    const currentMinute = nyTime.getMinutes();

    const isBefore11am = currentHour < 11 || (currentHour === 11 && currentMinute === 0);

    let deliveryInDays;

    switch (currentDay) {
        case 1: // Monday
            // FIX: Monday now respects the 11am cutoff like other weekdays
            deliveryInDays = isBefore11am ? 1 : 2;
            break;
        case 2: // Tuesday
        case 3: // Wednesday
            deliveryInDays = isBefore11am ? 1 : 2;
            break;
        case 4: // Thursday
            deliveryInDays = isBefore11am ? 1 : 3;
            break;
        case 5: // Friday
        case 6: // Saturday
            deliveryInDays = 3;
            break;
        case 0: // Sunday
            deliveryInDays = 2;
            break;
    }

    let displayText;
    if (locale === 'ru') {
        displayText = deliveryInDays <= 1 ? '2+ день' : `${deliveryInDays}+ дней`;
    } else {
        displayText = deliveryInDays <= 1 ? '2+ day' : `${deliveryInDays}+ days`;
    }

    return { displayText, locale };
}

function updateDeliveryElements(result) {
    const deliveryElements = document.querySelectorAll('.delivery-text');
    for (const element of deliveryElements) {
        element.textContent = result.displayText;
    }
}
